import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    Checkbox,
    FormControlLabel
} from '@material-ui/core'

import React, { useState, useEffect } from 'react'
import api from '../../config/api'

import * as yup from 'yup'
import { useForm, EventType } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify'

import {
    Container,
    ErrorMessage
} from './styles'

const formCreateScheme = yup.object().shape({
    description: yup.string().required('É necessário informar um nome para o grupo')
})


interface Role {
    id: number
    description: string
}

interface Scope {
    id: number
    description: string
}

export default function ManagePermission() {
    const [selectedGroup, setSelectedGroup] = useState<number>()
    const [roles, setRoles] = useState<Role[]>([])
    const [adminCheck, setAdminCheck] = useState(false)
    const [storeCheck, setStoreCheck] = useState(false)
    const [agroCheck, setAgroCheck] = useState(false)

    const { register, handleSubmit, formState: { errors }, reset } = useForm<{ description: string }>({
        resolver: yupResolver(formCreateScheme)
    })

    useEffect(() => {
        async function fetch() {
            const rolesResponse = await api.get<{ roles: Role[] }>('/roles')
            console.log(rolesResponse.data.roles)
            setRoles(rolesResponse.data.roles)
        }
        fetch()
    }, [])


    async function handleSelect(event: React.ChangeEvent<{
        name?: string | undefined;
        value: unknown
    }>) {
        const id = Number(event.target.value)
        setSelectedGroup(id)
        try {
            const responseScopes = await api.get<{ scopes: Scope[] }>(`/roles/scope/${id}`)
            const { scopes } = responseScopes.data

            setStoreCheck(scopes.find(scope => scope.description === 'Sicredi Store') ? true : false)
            setAgroCheck(scopes.find(scope => scope.description === 'Produção Rural') ? true : false)
            setAdminCheck(scopes.find(scope => scope.description === 'Admin') ? true : false)

        } catch (err) {
            console.log(err)
        }
    }

    async function handleSubmitForm({ description }: { description: string }) {
        try {
            const responseRole = await api.post(`/roles`, { description })
            const { role } = responseRole.data
            setRoles([...roles, {
                description: role.description,
                id: role.id
            }])
            reset()
            toast.success("Grupo criado com sucesso!")
        } catch (err) {
            if (err instanceof Error){
                toast.error(err.message)
            }else
                toast.error('Erro desconhecido!')
        }
    }

    async function handleDelete() {
        try {
            await api.delete(`/roles/${selectedGroup}`)
            const deletedIndex = roles.findIndex(item => item.id === selectedGroup)
            const auxRoles = [...roles]
            auxRoles.splice(deletedIndex, 1)

            setSelectedGroup(undefined)

            setRoles([...auxRoles])
            toast.success('Grupo deletado com sucesso!')
        } catch (err) {
            toast.error('Erro ao deletar grupo!')
        }
    }

    async function handleSubmitScopes(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault()
        if (!selectedGroup) {
            toast.error('Selecione um grupo para atualizar as permissões')
            return
        }
        try {
            const scopes: string[] = []
            if (adminCheck) scopes.push('Admin');
            if (storeCheck) scopes.push('Sicredi Store');
            if (agroCheck) scopes.push('Produção Rural');

            await api.post('/roles/scope', {
                role_id: selectedGroup,
                scopes
            })
            toast.success('Permissões atualizadas com sucesso!')
        } catch (err) {
            toast.error('Erro ao tentar atualizar permissões!')
            console.log(err)
        }
    }

    return (
        <Container>
            <Typography variant="h4" style={{ marginBottom: 30, fontWeight: 600 }}>
                Gerenciar Grupo de Permissões
            </Typography>
            <Typography variant="h5" style={{ marginTop: 30, marginBottom: 30, fontWeight: 600 }}>
                Deseja criar um novo grupo ?
            </Typography>
            <form onSubmit={handleSubmit(handleSubmitForm)}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <TextField
                        autoComplete="fname"
                        variant="outlined"
                        id="description"
                        label="Descrição"
                        {...register('description')}
                        autoFocus
                        error={errors.description ? true : false}
                        style={{ width: 350 }}
                    />
                    <Button
                        variant="contained"
                        type="submit"
                        color="secondary"
                        className="submit-button"
                        style={{
                            marginLeft:
                                10
                        }}>
                        Criar Grupo
                     </Button>
                </div>
                {errors.description && <ErrorMessage>{errors.description.message}</ErrorMessage>}

            </form>
            <Typography variant="h5" style={{ marginTop: 30, marginBottom: 30, fontWeight: 600 }}>
                Grupos disponiveis
            </Typography>
            <FormControl variant="outlined" style={{ width: 200 }}>
                <InputLabel id="demo-simple-select-outlined-label">Grupos</InputLabel>
                <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    label="Grupo"
                    defaultValue={0}
                    onChange={(event) => {
                        handleSelect(event)
                        console.log(event.target.value)
                    }}
                >
                    {
                        roles.map((role) =>
                            <MenuItem key={role.id} value={role.id}>
                                {role.description}
                            </MenuItem>
                        )
                    }
                </Select>
            </FormControl>
            {
                selectedGroup &&
                <>
                    <Typography variant="h5" style={{ marginTop: 30, marginBottom: 30, fontWeight: 600 }}>
                        Permissões disponiveis:
                    </Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="default"
                                inputProps={{ 'aria-label': 'checkbox with default color' }}
                                checked={adminCheck}
                                onChange={() => { setAdminCheck(!adminCheck) }}
                            />
                        }
                        style={{ width: 100 }}
                        label="Admin"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="default"
                                inputProps={{ 'aria-label': 'checkbox with default color' }}
                                checked={storeCheck}
                                onChange={() => { setStoreCheck(!storeCheck) }}
                            />
                        }
                        style={{ width: 150 }}
                        label="Sicredi Store"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="default"
                                inputProps={{ 'aria-label': 'checkbox with default color' }}
                                checked={agroCheck}
                                onChange={() => { setAgroCheck(!agroCheck) }}
                            />
                        }
                        style={{ width: 180 }}
                        label="Produção Geral"
                    />
                    <div
                        style={{
                            flexDirection: 'row',
                            display: 'flex',
                            marginTop: 20,
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            maxWidth: 500,
                            flexWrap: 'wrap'
                        }}>

                        <Button
                            variant="contained"
                            type="submit"
                            color="secondary"
                            className="submit-button"
                            style={{
                                width: 200,
                                height: 60,
                            }}
                            onClick={(event) => { handleSubmitScopes(event) }}
                        >
                            Atualizar Permissões
                        </Button>
                        <Button
                            variant="contained"
                            type="submit"
                            color="secondary"
                            className="submit-button"
                            style={{
                                width: 200,
                                height: 60,
                                backgroundColor: 'rgba(250,50,50)'
                            }}
                            onClick={handleDelete}
                        >
                            Deletar Grupo
                        </Button>
                    </div>
                </>
            }
        </Container >
    )
}